import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, roles, requireSuper = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div className="flex items-center justify-center h-screen bg-[#F8FAFC]">
        <div className="text-slate-600">Cargando...</div>
      </div>
    );
  }

  if (!user) {
    const back = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?redirect=${back}`} replace />;
  }

  // Force password change before anything else
  if (user.must_change_password) {
    return <Navigate to="/change-password" replace />;
  }

  // Gating de suscripción: bloquea toda la app del tenant si no está activa.
  // El Super Admin y el tenant principal (LGMG) nunca se bloquean (required=false).
  const sub = user.subscription;
  if (sub?.required && !sub?.allowed && location.pathname !== "/suscripcion") {
    return <Navigate to="/suscripcion" replace />;
  }

  if (requireSuper && !user.is_super) {
    return (
      <div className="flex items-center justify-center h-screen bg-[#F8FAFC]">
        <div className="text-center max-w-md">
          <h2 className="text-2xl font-bold text-[var(--brand,#E31E24)] mb-2">Acceso denegado</h2>
          <p className="text-slate-600">Esta sección está reservada al Super Admin.</p>
        </div>
      </div>
    );
  }

  if (roles && roles.length > 0 && !user.is_super && !roles.includes(user.role)) {
    return (
      <div className="flex items-center justify-center h-screen bg-[#F8FAFC]">
        <div className="text-center max-w-md">
          <h2 className="text-2xl font-bold text-[var(--brand,#E31E24)] mb-2">Acceso denegado</h2>
          <p className="text-slate-600">No tienes permisos para ver esta sección.</p>
        </div>
      </div>
    );
  }

  return children;
}
